var $574239e9a0c4ce9f$exports = {};
$574239e9a0c4ce9f$exports = {
    "decrease": (args)=>`Diminuer ${args.fieldLabel}`,
    "increase": (args)=>`Augmenter ${args.fieldLabel}`,
    "numberField": `Champ de nombre`
};


export {$574239e9a0c4ce9f$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
